<template>
    <header>
        <!--<div class="top-line">-->
        <!--    Внимание! На сайте ведутся технические работы. Приносим извинения за доставленные неудобства.-->
        <!--</div>-->
        <div class="header_top_sidebar_container">
            <div class="header_top_sidebar">
                <div class="textwidget">
                    <router-link title="Годовые медицинские программы" :to="{name: 'Программы годового обслуживания'}"
                    >Годовые медицинские программы →
                    </router-link>
                    <router-link title="Профосмотр" :to="{name: 'Медицинские осмотры по приказу 29н'}"
                    >Профосмотр →
                    </router-link>
                </div>
            </div>
        </div>
        <div class="header-layout header_container">

            <div class="header-layout--left">
                <router-link tag="a" :to="{name: 'Home'}">
                    <img alt="5-clinic" src="../../assets/images/001.png">
                </router-link>
            </div>

            <div class="header-layout--right">
                <div class="right-button">
                    <a href="/ru/cabinet/">Личный Кабинет</a>
                </div>
            </div>

        </div>


        <!--  Mobile Device  Header-->
        <div class="mobile-header">
            <mobile-dropdown-menu/>
        </div>
        <!-- End  Mobile Device  Header-->
    </header>
</template>

<script>
import NavigationLinks from "../NavigationLinks";
import MobileDropdownMenu from "../MobileDropdownMenu";

export default {
    name: "top",
    data() {
        return {}
    },
    components: {
        MobileDropdownMenu,
        NavigationLinks
    },

}
</script>

<style lang="scss" scoped>
.dropdown:hover .dropdown-content {
    display: block;
}

.dropdown-content .inner-list:hover .dropdown-content-inner {
    display: block;
}

.header_container {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 30px 0;
}

.header-layout {
    max-width: 990px;
    margin-left: auto;
    margin-right: auto;

    &__submenu {

        display: flex;
        justify-content: center;
        margin-bottom: -8px;

        @media screen and (max-width: 960px) {
            flex-wrap: wrap;
            justify-content: flex-start;
        }

        li > ul {
            display: none;
        }

        li:hover > .dropdown-content {
            display: block;
        }

        li a {
            padding: 15px;
            font-family: 'arial', sans-serif;
            color: #888;
            font-size: 14px;


        }

        .dropdown {
            &:hover, &.active {
                &:after {
                    display: none;
                }
            }

            &:after {
                z-index: 1;
                content: '';
                display: block;
                width: 1px;
                position: absolute;
                top: 2px;
                right: 0;
                height: 19px;
                background-color: #bcbcbc;
            }
        }

        li.active .dropdown-link, li:hover .dropdown-link {
            background-color: #00b6cc;
            border-color: #42B3E5;
            color: #FFF;
        }


        .dropdown {
            position: relative;
            display: inline-block;
            height: 35px;
            z-index: 9;
        }

        .dropdown-content {
            padding: 12px 15px;
            display: none;
            position: absolute;
            min-width: 160px;
            box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
            z-index: 1;
            left: 0;
            top: 33px;
            background-color: #fff;
        }

        .inner-list {
            position: relative;
        }

        .dropdown-content-inner {
            padding: 0 15px 12px;
            display: none;
            position: absolute;
            right: -150px;
            top: 7px;
            min-width: 160px;
            box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.2);
            z-index: 1;
            background-color: #fff;
        }

        .dropdown-content li {
            height: 44px;
        }

        .dropdown-content a {
            text-align: left;
            color: #888;
            font-size: 14px;
            text-decoration: none;
            display: block;
            border-bottom: 1px solid #b2b2b2;
        }

        .dropdown-content a:hover {
            color: black;
            border-bottom: 2px solid #00b6cc;
        }
    }

    &--left {
        img {
            width: 400px;
        }

        @media screen and (max-width: 420px) {
            img {
                width: 90%;
            }
        }
    }

    .right-button a {
        background-color: unset;
        border: 1px solid #006688;
        color: #006688;
        font-size: 15px;
        font-weight: bold;
        padding: 10px 20px;
        float: right;
        text-decoration: none;
    }

    .right-button:hover a {
        background-color: #006688;
        color: #FFF;
    }
}

.border-top-header {
    border-top: 1px solid #E8E8E8;
    padding-top: 10px;

}

.textwidget {
    display: flex;
    justify-content: flex-start;
}

.textwidget a:hover {
    background-color: #00b6cc;

}

.textwidget a {
    color: rgb(255, 255, 255);
    background-color: rgb(160, 32, 96);
    border-color: rgb(160, 32, 96);
    padding: 5px 24px 7px 8px;
    font-size: 12px;
    font-weight: bold;
}

.header_top_sidebar_container {
    background-color: #F7F7F7;
    border-bottom: 1px solid #EDEDED;
}

.header_top_sidebar {
    max-width: 990px;
    margin-left: auto;
    margin-right: auto;
}

.mobile-header {
    display: none;
}

.top-line {
    width: 100%;
    height: 23px;
    background: #FF0000 0 0 no-repeat padding-box;
    text-align: center;
    font: normal normal 600 12px/16px Avenir, Helvetica, Arial, sans-serif;
    letter-spacing: 0;
    color: #FFFFFF;
    padding: 2px 0 5px;
}

@media screen and (max-width: 768px) {
    .header-layout {
        display: flex;
        flex-direction: column;
        justify-content: center;
        padding-bottom: 5px;
    }
    .header_top_sidebar {
        width: 100%;
    }
    .textwidget {
        justify-content: center;
    }

    .mobile-header {
        display: block;
    }
}

</style>